import React from "react";
import { Banknote, Building2, IdCard, Hash, CalendarDays, BadgeInfo } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

// PLN formatter
const pln = (v) => {
  if (v == null || v === "" || v === "-") return <em>—</em>;
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n.toLocaleString("pl-PL", { style: "currency", currency: "PLN", maximumFractionDigits: 2 });
};

export default function PublicDebtSection({ items = [] }) {
  return (
    <Sekcja
      title="Dług publiczny"
      icon={Banknote}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      {Array.isArray(items) && items.length > 0 ? (
        <div style={{ display: "grid", gap: 12 }}>
          {items.map((d, i) => (
            <div key={i}>
              {/* Nagłówek wpisu (bez tła/borderów) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  marginBottom: 4,
                }}
              >
                <div style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700 }}>
                  <Banknote size={16} />
                  <span>{d?.company_name || "—"}</span>
                </div>
                <div style={{ fontWeight: 800 }}>{pln(d?.debt_amount)}</div>
              </div>

              {/* Wiersze danych w tym samym stylu co KRS */}
              <RowIcon icon={BadgeInfo} label="Źródło">
                {d?.source || <em>—</em>}
              </RowIcon>
              <RowIcon icon={CalendarDays} label="Ostatnia zmiana">
                {d?.last_update || <em>—</em>}
              </RowIcon>
              <RowIcon icon={Building2} label="Nazwa firmy">
                {d?.company_name || <em>—</em>}
              </RowIcon>
              <RowIcon icon={IdCard} label="NIP">
                {mono(d?.nip)}
              </RowIcon>
              <RowIcon icon={Hash} label="Ident. zewnętrzny">
                {mono(d?.external_ident)}
              </RowIcon>
            </div>
          ))}
        </div>
      ) : (
        <em>Brak rekordów zadłużenia publicznego.</em>
      )}
    </Sekcja>
  );
}
